import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@/components/ui";
import { PROMO } from "@/lib/content";
import { track } from "@/lib/track";

const DEFAULT_TRUST = ["Partner Home-Care Agencies", "Personalized Care Matching", "No Long-Term Commitment"];

/** Row of lightweight trust cues placed near CTAs. */
export function TrustSignals({ items = DEFAULT_TRUST, testID = "trust-signals" }) {
  return (
    <ul className="imm-trust" data-testid={testID}>
      {items.map((t, i) => (
        <li key={i} className="imm-trust-item"><Icon name="check-circle" size={16} /> <span>{t}</span></li>
      ))}
    </ul>
  );
}

/** Accurate promotional offer banner (code LINKED). */
export function PromoBanner({ testID = "promo-banner" }) {
  return (
    <div className="imm-promo" data-testid={testID}>
      <span className="imm-promo-badge"><Icon name="gift" size={16} /> {PROMO.headline}</span>
      <span className="imm-promo-detail">{PROMO.detail} <b>Promo code: {PROMO.code}</b></span>
    </div>
  );
}

/**
 * Crawlable + tracked CTA (renders a real <a href> via react-router Link).
 * `event` is an optional analytics intent (e.g. "get_matched").
 */
export function CtaLink({ to, label, icon, variant, testID, event, microcopy }) {
  return (
    <div className="imm-cta-wrap">
      <Link
        className={`imm-cta${variant ? ` ${variant}` : ""}`}
        to={to}
        data-testid={testID}
        onClick={() => track(event === "get_matched" ? "get_matched_clicked" : "cta_click", { cta: label, to })}
      >
        {icon ? <Icon name={icon} size={18} /> : null}{label}
      </Link>
      {microcopy ? <p className="imm-cta-micro">{microcopy}</p> : null}
    </div>
  );
}

/** Standard above/below-section CTA cluster used across marketing pages. */
export function CtaCluster({ showTrust = true, showPromo = false }) {
  return (
    <>
      <div className="imm-cta-row">
        <CtaLink to="/intake" label="Get Matched Now" icon="heart" testID="cta-get-matched" event="get_matched"
          microcopy="Tell us your care needs, preferences, location, and preferred start date." />
        <CtaLink to="/book-appointment" label="Book an Appointment" icon="calendar" variant="ghost" testID="cta-book" />
        <CtaLink to="/how-it-works" label="Learn How It Works" icon="arrow-right" variant="ghost" testID="cta-how" />
      </div>
      {showTrust ? <TrustSignals /> : null}
      {showPromo ? <PromoBanner /> : null}
    </>
  );
}
